import * as React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from 'components/ui/dialog';
import { Button } from 'components/ui/button';

interface ConfirmDeletePingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pingId?: number;
  pingType?: string;
  pingIndex?: number;
  onConfirm: (pingId: number, pingType: string, pingIndex: number) => void;
}

export const ConfirmDeletePingDialog: React.FC<ConfirmDeletePingDialogProps> = ({
  open,
  onOpenChange,
  pingId,
  pingType,
  pingIndex,
  onConfirm
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[420px]">
        <DialogHeader>
          <DialogTitle>Delete ping</DialogTitle>
          <DialogDescription>
            This will remove the ping from the map and customers will no longer be able to see this location.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            className="bg-red-600 hover:bg-red-700"
            onClick={() => {
              if (pingId != null && pingType) onConfirm(pingId, pingType, pingIndex ?? 0);
            }}
          >
            Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
